'use strict';

var createEnum = require('./createEnum');

module.exports = createEnum(['GODADDY', 'RESELLER']);